import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/reduxtoolkit/store/store";
import { useInfiniteQuery, useQuery } from "react-query";
import axiosInstance from "@/api/axiosInstance";
import { endpoints } from "@/api/endpoints";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;

